import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Location from "../../interfaces/Location";
import { getLocation } from "../../utils/api/LocationApi";
import { RootState } from "../store/store";
import { IDLE, LOADING, SUCCEEDED, FAILED, NEEDS_REFRESH } from "./constants";

export interface LocationsState {
  locations: Location[];
  status: string;
  error: any;
  lastUpdated: String;
}

const initialState: LocationsState = {
  locations: [],
  status: IDLE,
  error: null,
  lastUpdated: "",
};

export const fetchLocations = createAsyncThunk(
  "/locations?includeAllCategories=true",
  async (param, thunkAPI) => {
    const locationList: any[] = await getLocation();
    return locationList;
  }
);

export const locationsSlice = createSlice({
  name: "location",
  initialState,
  reducers: {
    //when updates to the delivery  are made while using the app, this alerts
    //redux that a refresh is needed to the store
    alertRefreshLocations: (state) => {
      state.status = NEEDS_REFRESH;
    },
    updateLocation: (state, action) => {
      state.locations = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchLocations.pending, (state, action) => {
        state.status = LOADING;
      })
      .addCase(fetchLocations.fulfilled, (state, action) => {
        state.status = SUCCEEDED;
        state.locations = action.payload;
      })
      .addCase(fetchLocations.rejected, (state, action) => {
        state.status = FAILED;
        state.error = action.error.message;
      });
  },
});

export default locationsSlice.reducer;
export const { alertRefreshLocations, updateLocation } = locationsSlice.actions;
export const locationSelector = (state: RootState) => state.locations.locations;
